import "./PrimaryBtn.scss";

const PrimaryBtn = ({title, theme, type="button", clickHandler}) => {
    return(
        <button onClick={clickHandler} className={`primary_btn ${theme}`}><span>{title}</span></button>
    )
}

export default PrimaryBtn;